module.exports = __webpack_public_path__ + "img/print-icon.00099a1a.svg";